import { UserRole } from '../UserRole';

export default function can_create_new_project(user) {
  return UserRole.ADMIN === user.role || UserRole.PROJECT_LEAD === user.role;
}
